import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { appDataInitialState, useApp } from './hooks';

export const defaultAppContext = {
  companyId: appDataInitialState.companyId,
  companyName: appDataInitialState.companyName,
  isAuthorized: () => {},
  isInternalMode: appDataInitialState.isInternalMode,
  isLoggedIn: appDataInitialState.isLoggedIn,
  isReady: appDataInitialState.isReady,
  mergeTags: {},
  setIsReady: () => {},
  username: appDataInitialState.username,
  userRole: appDataInitialState.userRole,
};

export const AppContext = createContext(defaultAppContext);

export const AppContextProvider = ({ children }) => {
  const {
    companyId,
    companyName,
    isAuthorized,
    isInternalMode,
    isLoggedIn,
    isReady,
    mergeTags,
    setIsReady,
    username,
    userRole,
  } = useApp();

  const values = {
    companyId,
    companyName,
    isAuthorized,
    isInternalMode,
    isLoggedIn,
    isReady,
    mergeTags,
    setIsReady,
    username,
    userRole,
  };

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

AppContextProvider.propTypes = {
  children: PropTypes.node,
};

export const useAppContext = () => useContext(AppContext);
